<template>
  <div class="user-mgmt">
    <div class="header-box">
      <div class="header-line">
        <span class="header-label">微信昵称</span>
        <el-input placeholder="请输入微信昵称" v-model="userName" size="small" clearable>
        </el-input>
        <span class="header-label">花名</span>
        <el-input placeholder="请输入花名" v-model="nickname" size="small" clearable>
        </el-input>
        <span class="header-label">角色</span>
        <el-select v-model="role" size="small">
          <el-option v-for="item in roleList" :key="item.vlue" :label="item.label" :value="item.vlue">
          </el-option>
        </el-select>
        <span class="header-label">状态</span>
        <el-select v-model="status" size="small">
          <el-option v-for="item in statusList" :key="item.status" :label="item.label" :value="item.status">
          </el-option>
        </el-select>
        <el-button type="primary" size="small" v-on:click="onQueryBtnClick">查询</el-button>
      </div>
    </div>
    <el-table :data="tableData" border style="width: 831px;" cell-class-name="table-cell"
            row-class-name="table-row" header-cell-class-name="table-header-cell">
      <el-table-column label="序号" width="80px">
        <template slot-scope="scope">
          {{beginIndex + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="userName" label="微信昵称" width="150px">
      </el-table-column>
      <el-table-column prop="nickname" label="花名" width="150px">
      </el-table-column>
      <el-table-column label="角色" width="150px">
        <template slot-scope="scope">
          {{getDisplayRole(scope.row)}}
        </template>
      </el-table-column>
      <el-table-column label="状态" width="150px">
        <template slot-scope="scope">
          {{getDisplayStatus(scope.row)}}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150px">
        <template v-slot="scope">
          <el-button type="text" v-on:click="onEditClick(scope.row)" style="padding: 5px 10px;">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination layout="prev, next" background prev-text="上一页" next-text="下一页" :page-count="totalPage" @prev-click="prevBtnClick"
      @next-click="nextBtnClick">
    </el-pagination>
    <el-dialog title="编辑用户" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item label="微信昵称" :label-width="formLabelWidth">
          <el-input v-model="form.userName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="花名" :label-width="formLabelWidth">
          <el-input v-model="form.nickname" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="角色" :label-width="formLabelWidth">
          <el-radio-group v-model="form.role">
            <el-radio :label="5">普通用户</el-radio>
            <el-radio :label="8">质检员</el-radio>
            <el-radio :label="6">管理员</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="状态" :label-width="formLabelWidth">
          <el-radio-group v-model="form.status">
            <el-radio :label="0">启用</el-radio>
            <el-radio :label="1">待审核</el-radio>
            <el-radio :label="2">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="onEditDialogClick">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import {
    userModules
  } from '@r'
  export default {

    data() {
      return {
        statusList: [{
            status: "",
            label: "全部"
          },
          {
            status: "0",
            label: "启用"
          },
          {
            status: "1",
            label: "待审核"
          },
          {
            status: "2",
            label: "停用"
          }
        ],
        status: "0",
        roleList: [{
            vlue: "",
            label: "全部"
          },
        ],
        role: "",
        tableData: [],
        beginIndex: 0,
        pageSize: 20,
        totalPage: 1,
        currentPage: 1,
        userName: "",
        nickname: "",
        dialogFormVisible: false,
        form: {
          userName: '',
          nickname: '',
          role: '',
          status: ''
        },
        formLabelWidth: '120px'
      }
    },
    activated() {
      userModules.getRoleEnum(this.form).then((res) => {
        if (res.result !== 1) {
          this.$message({
            type: 'error',
            message: res.message ? res.message : '查询角色列表失败'
          });
          return
        }
        res.ldata.forEach(role=>{
          this.roleList.push(role);
        })
      }).catch((err) => {
        this.$message({
          type: 'error',
          message: err.message ? err.message : '未知错误'
        });
      })
      this.getUsers();
    },
    methods: {
      getDisplayRole(row) {
        var roleLabel = "--";
        row.role == "5" && (roleLabel = "普通用户");
        row.role == "6" && (roleLabel = "管理员");
        row.role == "7" && (roleLabel = "超级管理员");
        row.role == "8" && (roleLabel = "质检员");
        return roleLabel
      },
      getDisplayStatus(row) {
        var statusLabel = "--";
        row.status == "0" && (statusLabel = "启用");
        row.status == "1" && (statusLabel = "待审核");
        row.status == "2" && (statusLabel = "停用");
        return statusLabel
      },
      prevBtnClick() {
        if (this.beginIndex <= 0) {
          this.$message({
            type: 'info',
            message: '已经到头了!'
          })
          return;
        }
        this.beginIndex = this.beginIndex - this.pageSize;
        this.getUsers();
      },
      nextBtnClick() {
        if (this.tableData.length < this.pageSize) {
          this.$message({
            type: 'info',
            message: '没有更多了!'
          })
          return;
        }
        this.beginIndex = this.beginIndex + this.pageSize;
        this.getUsers();
      },
      onQueryBtnClick(){
        this.beginIndex=0;
        this.getUsers();
      },
      getUsers() {
        userModules.getUsers({
          status: this.status,
          role: this.role,
          userName: this.userName,
          nickname: this.nickname,
          beginIndex: this.beginIndex,
          pageSize: this.pageSize + 1
        }).then((res) => {
          if (res.result !== 1) {
            this.$message({
              type: 'error',
              message: res.message ? res.message : '获取权限列表失败'
            });
            return
          }

          this.tableData = res.ldata;
          this.currentPage = this.beginIndex / this.pageSize + 1;
          if (this.tableData.length >= this.pageSize) {
            this.tableData.pop();
            this.totalPage = this.currentPage + 1;
          }
        }).catch((err) => {
          this.$message({
            type: 'error',
            message: err.message ? err.message : '未知错误'
          });
        })
      },
      onEditClick(row) {
        this.form={
          userName: row.userName,
          nickname: row.nickname,
          role: row.role,
          status: row.status,
          id: row.id
        }
        this.dialogFormVisible=true;
      },
      onEditDialogClick(){
        userModules.editUser(this.form).then((res) => {
          if (res.result !== 1) {
            this.$message({
              type: 'error',
              message: res.message ? res.message : '编辑失败'
            });
            return
          }
          this.$message({
            type: 'success',
            message: res.message ? res.message : '编辑成功'
          });
          this.dialogFormVisible=false;
          this.getUsers();
        }).catch((err) => {
          this.$message({
            type: 'error',
            message: err.message ? err.message : '未知错误'
          });
        })
      }
    }
  }
</script>

<style lang="scss">
</style>
